import React, { useState, useEffect } from "react"
import axios from "axios"
import { component } from "picoapp";
import { createRoot } from "react-dom/client"


const initStates = ["AL",
"AK",
"AS",
"AZ",
"AR",
"CA",
"CO",
"CT",
"DE",
"DC",
"FL",
"GA",
"GU",
"HI",
"ID",
"IL",
"IN",
"IA",
"KS",
"KY",
"LA",
"ME",
"MD",
"MA",
"MI",
"MN",
"MS",
"MO",
"MT",
"NE",
"NV",
"NH",
"NJ",
"NM",
"NY",
"NC",
"ND",
"MP",
"OH",
"OK",
"OR",
"PA",
"PR",
"RI",
"SC",
"SD",
"TN",
"TX",
"UT",
"VT",
"VA",
"VI",
"WA",
"WV",
"WI",
"WY",
]
const initFormValues = {
  fName: "",
  lName: "",
  email: "",
  State: "",
  City: "",
  Zip: 0,
  consent: false
}
function WaterTemp({node, ctx}) {
  const [formValues, setFormValues] = useState(initFormValues)
  const [cityOptions, setCityOptions] = useState()
  const [zipOptions, setZipOptions] = useState()
  const [initResults, setInitResults] = useState()
  const [formLoading, setFormLoading] = useState(true)
  const [reportLoading, setReportLoading] = useState(false)
  const [tempObject, setTempObject] = useState()
  useEffect(()=> {
    axios.get("https://script.google.com/macros/s/AKfycbw8YXbUem4WhOGyaZq8ft8o1p24sdsS9FQUb451YqrHJXWFaIIsoiJN_mm5nUTpUrD0cQ/exec?action=formatSpreadsheetData")
    .then(response => {
      setInitResults(response.data)
      setFormLoading(false);
    })
  }, [])
  const handleSubmit = e => {
    e.preventDefault();
    const options = {
      method: 'POST',
      headers: {revision: '2024-02-15', 'content-type': 'application/json'},
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Homepage footer signup form',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: formValues.email,
                  first_name: formValues.fName,
                  last_name: formValues.lName
                }
              }
            }
          },
          relationships: {list: {data: {type: 'list', id: 'SXzdfC'}}}
        }
      })
    };
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=RZUpfX', options)
    .then(response => {
        const newTempObject = initResults.filter(res => res.Zip == formValues.Zip)
        setTempObject(newTempObject[0])
      })
      .catch(err => {console.error(err)});
  }
  return (
    <>
    
    <div className="WaterTemp__wrapper">
      {formLoading ? <div className="temp-loading">Loading Water Temp Form...</div> : <form onSubmit={handleSubmit}>
        <input name="fName" type="text" placeholder="First name" required value={formValues.fName} onChange={e=> setFormValues({...formValues, [e.target.name]: e.target.value})}></input>
        <input name="lName" type="text" placeholder="Last name" required value={formValues.lName} onChange={e=> setFormValues({...formValues, [e.target.name]: e.target.value})}></input>
        <input name="email" type="email" placeholder="Email" required value={formValues.email} onChange={e=> setFormValues({...formValues, [e.target.name]: e.target.value})}></input>
        <select name="State" value={formValues.State} defaultValue="" required onChange={(e) => {
          setFormValues({...formValues, [e.target.name]: e.target.value, City: "", Zip: 0})
          let newCities = initResults.map(res => {
            if (res.State === e.target.value) {
              return res.City
            }
          })
          newCities = newCities.filter((res, i)=> newCities.indexOf(res) === i && true).sort()
          setCityOptions(newCities)
          }}>
          <option value="" disabled>Select your state</option>
          {initStates.map(state => (
            <option key={state} value={state}>{state}</option>
          ))}
        </select>
        <select name="City" value={formValues.City} defaultValue="" disabled={formValues.State === ""} required onChange={(e) => {
          setFormValues({...formValues, [e.target.name]: e.target.value})
          let newZips = initResults.map(res => {
            if (res.City === e.target.value && res.State === formValues.State) {
              return res.Zip
            }
          })
          newZips = newZips.filter((res, i)=> newZips.indexOf(res) === i && true).sort()
          setZipOptions(newZips)
          }}>
          <option value="" disabled>{formValues.State === "" ? "Please select a state first" : "Select your city"}</option>
          {cityOptions && cityOptions.map((res, i) => (
            res && <option key={i} value={res}>{res}</option>
          ))}
        </select>
        <select name="Zip" defaultValue={0} value={formValues.Zip} disabled={formValues.City === ""} required onChange={(e) => {
          setFormValues({...formValues, [e.target.name]: e.target.value})
          }}>
          <option value={0} disabled>{formValues.City === "" ? "Please select a city first" : "Select your zipcode"}</option>
          {zipOptions && zipOptions.map((res, i) => (
            res && <option key={i} value={res}>{res}</option>
          ))}
        </select>
        <div className="consent-row">
          <input id="consent" type="checkbox" value={formValues.consent} onChange={e=> {
            setFormValues({...formValues, consent: !formValues.consent})
          }}/>
          <label htmlFor="consent">I agree to receive marketing emails from Silient</label>
        </div>
        <button className="btn btn--secondary" disabled={!formValues.fName || !formValues.lName || !formValues.email || !formValues.State || !formValues.City || !formValues.Zip || !formValues.consent }>Submit</button>
      </form>
      }
      <div className="WaterReport">
        <h3>Your Water Temperature Report</h3>
        <div className="report-fields">
          <div className="report-zip"><span>Zip Code:</span> {tempObject ? tempObject.Zip : null}</div>
          <div className="report-months">
            <div className="report-month"><span>Jan:</span> {tempObject ? tempObject.Jan : null}</div>
            <div className="report-month"><span>Feb:</span> {tempObject ? tempObject.Feb : null}</div>
            <div className="report-month"><span>Mar:</span> {tempObject ? tempObject.Mar : null}</div>
            <div className="report-month"><span>Apr:</span> {tempObject ? tempObject.Apr : null}</div>
            <div className="report-month"><span>May:</span> {tempObject ? tempObject.Jan : null}</div>
            <div className="report-month"><span>Jun:</span> {tempObject ? tempObject.Jun : null}</div>
            <div className="report-month"><span>Jul:</span> {tempObject ? tempObject.Jul : null}</div>
            <div className="report-month"><span>Aug:</span> {tempObject ? tempObject.Aug : null}</div>
            <div className="report-month"><span>Sep:</span> {tempObject ? tempObject.Sep : null}</div>
            <div className="report-month"><span>Oct:</span> {tempObject ? tempObject.Oct : null}</div>
            <div className="report-month"><span>Nov:</span> {tempObject ? tempObject.Nov : null}</div>
            <div className="report-month"><span>Dec:</span> {tempObject ? tempObject.Dec : null}</div>
          </div>
        </div>
      </div>
    
    </div>
    </>
  )
}



// module.exports = Slider;
export default component((node, ctx) => {
  const element = <WaterTemp node={node} ctx={ctx} />;
  const root = createRoot(node);
  root.render(element);

  return function () {
    try {
      ReactDOM.unmountComponentAtNode(node);
    } catch (e) {
      console.error(e);
    }
  };
});
